import { erpAxios } from '..';

const getApplications = async (id) => {
  const { data } = await erpAxios(`/loanApplication/getApplications/${id}`);
  return data;
};

export default getApplications;
